module.exports = __webpack_public_path__ + "img/user.d9fb6bad.svg";